var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// TEAM_UPDATE_TICKET_TYPES
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamUpdateTicketTypes($add_ids: [ID!], $team_id: ID!, $remove_ids: [ID!]) {\n    teamUpdateTicketTypes(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"], ["\n  mutation TeamUpdateTicketTypes($add_ids: [ID!], $team_id: ID!, $remove_ids: [ID!]) {\n    teamUpdateTicketTypes(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"])));
export default function useTeamUpdateTicketTypesMutation() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamUpdateTicketTypes',
        successMessage: 'Team ticket types updated'
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
